/*=========================================================================================
  File Name: moduleStatusActions.js
  Description: Status Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	// Consulta los estatus
	getStatus({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/status")
				.then((res) => {
					commit("SET_STATUS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea un estatus
	addStatus({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/status", object)
				.then((response) => {
					this.dispatch("moduleStatus/getStatus");
					//commit('SET_STATUS_ONLY', object)
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza el Status
	updateStatus({commit}, object) {
		let id = object.id;
		delete object["id"];
		return new Promise((resolve, reject) => {
			Api.put(`/status/${id}`, JSON.stringify(object))
				.then((response) => {
					this.dispatch("moduleStatus/getStatus");
					//commit('UPDATE_STATUS', response.data)
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Elimina el Status
	removeStatus({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/status/${itemId}`)
				.then((response) => {
					commit("REMOVE_STATUS", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
